/* eslint-disable no-unused-vars */
import * as S from '../AudienceManagement.styled';
import { TableCell } from 'components';

export const TableHeader = ({ requestSort, getClassNamesFor }) => {
  return (
    <S.TableRow>
      <TableCell.Component
        width={300}
        size={TableCell.sizes[40]}
        value='cust_aud_name'
        onClick={requestSort}
        direction={getClassNamesFor('cust_aud_name')}
      >
        Audience Name
      </TableCell.Component>
      <TableCell.Component
        width={124}
        size={TableCell.sizes[40]}
        value='devices_count'
        onClick={requestSort}
        direction={getClassNamesFor('devices_count')}
      >
        Devices
      </TableCell.Component>
      <TableCell.Component
        width={93}
        size={TableCell.sizes[40]}
        value='campaigns'
        onClick={requestSort}
        direction={getClassNamesFor('campaigns')}
      >
        Campaigns
      </TableCell.Component>
      <TableCell.Component
        width={123}
        size={TableCell.sizes[40]}
        value='associated_apps_count'
        onClick={requestSort}
        direction={getClassNamesFor('associated_apps_count')}
      >
        Associated Apps
      </TableCell.Component>
      <TableCell.Component width={40} size={TableCell.sizes[40]} hideSorting />
      <TableCell.Component width={40} size={TableCell.sizes[40]} hideSorting />
    </S.TableRow>
  );
};
